import {
  AdminPanelSettingsOutlined,
  LogoutOutlined,
  MenuOutlined,
  PersonOutline,
  SettingsOutlined,
} from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@/auth';
import { AdminPanel } from '@/pages';
import { NotificationCenter, UIMenu, UserAvatar } from '@/shared/components';
import { globalEnums, RoutesEnum } from '@/shared/duck';
import { useMedia } from '@/shared/hooks';

interface AuthorizationSectionProps {
  toggleMobileMenu: () => void;
}

const AuthorizationSection: React.FC<AuthorizationSectionProps> = ({
  toggleMobileMenu,
}) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const { isSmallScreen } = useMedia();
  const [openAdminPanel, setOpenAdminPanel] = React.useState(false);
  const isAdmin = React.useMemo(() => user?.roles?.includes(globalEnums.ERoles.Admin) ?? false, [user]);

  const handleLogout = async () => {
    logout();
    await navigate(RoutesEnum.Root);
  }

  return (
    <>
      <Stack flexDirection={'row'} alignItems="center" gap='1.5rem'>
        <NotificationCenter />
        <UIMenu
          type={globalEnums.EMenuType.COMPLEX}
          itemList={[
            {
              title: 'Admin Panel',
              itemAction: () => setOpenAdminPanel(true),
              titleIcon: <AdminPanelSettingsOutlined />,
              isHidden: !user?.roles?.includes(globalEnums.ERoles.Admin),
            },
            {
              title: 'Profile (ToDo)',
              itemAction: () => null,
              titleIcon: <PersonOutline />,
            },
            {
              title: 'Account Settings (ToDo)',
              itemAction: () => null,
              titleIcon: <SettingsOutlined />,
            },
          ]}
          headerIconC={
            <UserAvatar
              fullName={user?.name || 'User Name'}
              src={user?.pictureUrl || ''}
              withFullNameText
              description={user?.email}
              roles={user?.roles || []}
              isAdmin={isAdmin}
            />
          }
          footerItems={[
            {
              title: 'Logout',
              isRedText: true,
              itemAction: () => handleLogout(),
              titleIcon: <LogoutOutlined color="error" />,
            },
          ]}
          menuIconC={
            <UserAvatar
              fullName={user?.name || 'User Name'}
              src={user?.pictureUrl || ''}
              roles={user?.roles || []}
              isAdmin={isAdmin}
            />
          }
        />

        {isSmallScreen && (
          <IconButton onClick={toggleMobileMenu} color="inherit">
            <MenuOutlined />
          </IconButton>
        )}
      </Stack>

      {openAdminPanel && (
        <AdminPanel isOpen={openAdminPanel} onClose={() => setOpenAdminPanel(false)} />
      )}
    </>
  );
};

export default AuthorizationSection;